import { useMemo as s } from "react";
import { l as a } from "../lodash-DeBCDn4U.js";
const t = (o) => s(() => !!o.growth, [o.growth]), r = (o) => s(() => o.additionalFilters.length > 0, [o.additionalFilters]), f = (o) => s(() => !a.isEmpty(o == null ? void 0 : o.overridePeriod), [o == null ? void 0 : o.overridePeriod]), i = (o) => s(() => {
  var n, d, l;
  return !a.isEmpty(o) && !a.isEmpty(o.extraConf) && (!!o.extraConf.details || !!o.extraConf.units || !!o.extraConf.decimals || !!((n = o.extraConf) != null && n.color) || !!((d = o.extraConf) != null && d.interval) || !!((l = o.extraConf) != null && l.gradient));
}, [o]);
export {
  i as useHasDisplayOptionApplied,
  r as useHasFilterApplied,
  t as useHasGrowthApplied,
  f as useHasPeriodApplied
};
//# sourceMappingURL=MetricDisplay.hooks.js.map
